
import React, { PureComponent } from 'react';
import { Row, Col, Card, InputGroup, FormControl, Button, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ListPrices } from './list';
import NumberFormat from 'react-number-format';
import { ModalRegistro } from './modal-registro';
import { ModalBoletas } from './modal-boletas';
import { searchNumber } from '../../../services/rifa.service';
import { searchClient } from '../../../services/cliente.service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Desencrypt } from '../../../utilities/cipher';
import { Transaction } from '../../../services/product.service';
import { FormatMoney } from '../../../utilities/formats';
import { ManagmentErrors } from '../../../shared/components/managmentErrors';
import { LoadingMovilGo } from '../../../shared/components/loadingMovilGo';
import { ModalNotificationTransaction } from '../../../shared/components/modalNotificationTransaction';
import { jsPdfGenerator } from '../../../shared/components/pdfTransaction';
import './styles.css';
import { Url_Home, Url_pago, idCallcenter, idCardosoVendedor, idMobilgoVendedor, idPadreRata, idvendedorqr } from '../../../utilities/odoo-config';
import Swal from 'sweetalert2';

class Compras extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            selectedPrice: '',
            boleta: '',
            visibleRegistro: false,
            visibleBoletas: false,
            creditoRifa: '',
            buyMessage: <></>,
            selectedTickets: [],
            numberTicket: '',
            identification: '',
            userPhone: '',
            userTicket: '',
            message: <></>,
            styleTicket: {},
            styleUser: {},
            viewTicket: false,
            viewUserTicket: false,
            partner_id: -1,
            prices: [],
            fullNameUser: '',
            loading: false,
            opacity: 1,
            modalNotification: false,
            rifa: JSON.parse(localStorage.getItem('datosRifa')),
            idProduct: -1,
            showcomprar: true,
            whoPress: '',
            pricesDisabled: false,
        };
        this.numbersTicket = [];
        this.allNumbersTicket = [];
    }

    componentDidMount = () => {
        const datoSession = Desencrypt();
        if (
            datoSession.id === idCardosoVendedor ||
            datoSession.id === idMobilgoVendedor ||
            datoSession.id === idCallcenter ||
            datoSession.id === idvendedorqr
        ) {
            this.setState({ showcomprar: false });
        } else {
            this.setState({ showcomprar: true });
        }
        this.price();
    }

    calcularAbono = (price, valorRifa) => {
        if (price == valorRifa) {
            this.setState({ buyMessage: <h5>Pago Completo</h5> });
        } else if (price >= valorRifa) {
            this.setState({ buyMessage: <h5>Pago Supera el valor de la rifa</h5> });
        } else if (price < (this.state.rifa.precio * this.state.rifa.porcentaje_recaudo) / 100) {
            this.setState({ buyMessage: <h5>Monto mínimo para comprar esta boleta es de {FormatMoney((this.state.rifa.precio * this.state.rifa.porcentaje_recaudo) / 100)}</h5> });
        } else {
            this.setState({ buyMessage: <h5>Se Abonará: {FormatMoney(price)}</h5> });
        }
    }

    selectTicket = (number) => {
        this.setState(
            (prevState) => {
                const { selectedTickets, rifa } = prevState;
                const isSelected = selectedTickets.some((ticket) => ticket.numero === number);

                if (rifa.porcentaje_recaudo !== 100 && selectedTickets.length >= 1 && !isSelected) {
                    toast.warning("Solo se permite seleccionar un boleto para esta rifa.");
                    return null;
                }

                if (isSelected) {
                    toast.info(`Boleto ${number} eliminado de la selección.`);
                    return {
                        selectedTickets: selectedTickets.filter((ticket) => ticket.numero !== number),
                        pricesDisabled: false,
                        selectedPrice: '',
                        buyMessage: <></>,
                    };
                } else {
                    const newTicket = {
                        numero: number,
                        precio: rifa.precio || 0,
                    };
                    toast.success(`¡Boleto ${number} agregado exitosamente!`);
                    return {
                        selectedTickets: [...selectedTickets, newTicket].sort((a, b) => a.numero - b.numero),
                        pricesDisabled: true,
                        selectedPrice: '',
                        buyMessage: <></>,
                    };
                }
            },
            () => {
                this.setState({
                    styleTicket:
                        this.state.selectedTickets.length > 0
                            ? { borderWidth: 2, borderColor: '#00A3B6' }
                            : { borderWidth: 1 },
                    viewTicket: this.state.selectedTickets.length > 0,
                });
            }
        );
    }

    removeSelectedTicket = (ticketId) => {
        this.setState(
            (prevState) => ({
                selectedTickets: prevState.selectedTickets.filter((ticket) => ticket.id !== ticketId),
                pricesDisabled: prevState.selectedTickets.length <= 1,
                selectedPrice: '',
                buyMessage: <></>,
            }),
            () => {
                if (this.state.selectedTickets.length === 0) {
                    this.setState({ styleTicket: { borderWidth: 1 }, viewTicket: false });
                }
                toast.info("Boleto eliminado de la selección.");
            }
        );
    }

    selectPrice = (price) => {
        const rifa = JSON.parse(localStorage.getItem('datosRifa'));
        this.calcularAbono(price, rifa.precio);
        if (typeof price === 'string' && price.toLowerCase() === 'otro valor') {
            this.setState({ visible: true, selectedPrice: '' });
        } else if (typeof price === 'string' && price.toLowerCase() === 'reservar') {
            this.setState({ selectedPrice: '0', visible: false });
        } else {
            this.setState({ selectedPrice: price, visible: false });
        }
        this.price();
    }

    showModalRegistro = (flag) => {
        this.setState({ visibleRegistro: flag, boleta: '' });
    }

    chooseTicket = (flag) => {
        this.setState((prevState) => ({
            visibleBoletas: flag,
            styleTicket:
                prevState.selectedTickets.length > 0
                    ? { borderWidth: 2, borderColor: '#00A3B6' }
                    : { borderWidth: 1 },
            viewTicket: prevState.selectedTickets.length > 0,
            whoPress: '',
        }));
    }

    foundNumber = (response, flag) => {
        const encontrada = () => toast.info("¡Se encontró la boleta solicitada!");
        const boletasRelacionadas = () =>
            toast.warning("¡No se encontró la boleta solicitada, pero hay algunas con relación!");

        if (flag) {
            this.allNumbersTicket = response.disponibles;

            if (response?.errores) {
                toast.error("Se produjo un error al consultar la boleta");
                this.setState({ loading: false, opacity: 1 });
                return;
            }

            if (response.disponibles.length > 0) {
                let numbersToShowInModal = [];
                this.setState({ idProduct: response.disponibles[0]?.product_id || -1 });

                if (this.state.whoPress === "numeroJugar") {
                    for (let k = 0; k < Math.min(6, response.disponibles.length); k++) {
                        numbersToShowInModal.push(response.disponibles[k]);
                    }
                    toast.info(`Aquí tienes hasta 6 números para jugar.`);
                } else {
                    numbersToShowInModal = response.disponibles;

                    const exactMatch = response.disponibles.some(
                        (item) => item.numero_boleta === this.state.numberTicket
                    );
                    if (!exactMatch && this.state.numberTicket !== '') {
                        boletasRelacionadas();
                    } else if (exactMatch) {
                        encontrada();
                    }
                }

                if (numbersToShowInModal.length > 0) {
                    this.numbersTicket = numbersToShowInModal;
                    this.setState({
                        visibleBoletas: true,
                        loading: false,
                        opacity: 1,
                    });
                } else {
                    toast.error("No se encontraron boletas disponibles para su solicitud.");
                    this.setState({ loading: false, opacity: 1 });
                }
            } else {
                toast.error("No se encontraron boletas disponibles para su búsqueda.");
                this.setState({ loading: false, opacity: 1 });
            }
        } else {
            toast.error("Se produjo un error al consultar las boletas.");
            this.setState({ loading: false, opacity: 1 });
        }
    }

    searchTicket = () => {
        const errorDigitar = () => toast.error("Por favor, ingrese un número de 4 dígitos");
        const rifa = JSON.parse(localStorage.getItem('datosRifa'));

        if (this.state.numberTicket.trim() !== '' && /^[0-9]{4}$/.test(this.state.numberTicket)) {
            this.setState({ loading: true, opacity: 0.4, whoPress: 'search' });
            searchNumber(this.state.numberTicket, rifa.id, this.foundNumber);
        } else {
            errorDigitar();
        }
    }

    numeroDeLaSuerte = () => {
        const min = 1;
        const max = 999;
        const numeroAleatorio = Math.floor(Math.random() * (max - min)) + min;

        this.setState({
            whoPress: 'numeroJugar',
            numberTicket: '',
            loading: true,
            opacity: 0.4,
        });

        searchNumber(String(numeroAleatorio), this.state.rifa.id, this.foundNumber);
    }

    foundClient = (response, flag) => {
        const encontre = () => toast.info("¡Usuario encontrado!");
        const noEncontre = () => toast.error("¡Usuario no encontrado, por favor registrarlo!");

        if (flag) {
            if (response.name !== false) {
                encontre();
                this.setState({
                    loading: false,
                    opacity: 1,
                    userTicket: response.name,
                    styleUser: { borderWidth: 2, borderColor: '#00A3B6' },
                    viewUserTicket: true,
                    partner_id: response.partner_id,
                    userPhone: response.celular,
                    userEmail: response.email,
                    fullNameUser: (response.nombre.trim() + ' ' + response.apellido.trim()),
                });
            } else {
                noEncontre();
                this.setState({ visibleRegistro: true, loading: false, opacity: 0.8 });
            }
        }
    }

    findClient = () => {
        const errorDigitar = () => toast.error("¡No se le olvide digitar un número de cédula!");
        const rifa = JSON.parse(localStorage.getItem('datosRifa'));

        if (this.state.identification.trim() !== '') {
            this.setState({ loading: true, opacity: 0.4 });
            searchClient(rifa.id, this.state.identification, this.foundClient);
        } else {
            errorDigitar();
        }
    }

    handleChange = (event) => {
        this.setState({
            numberTicket: event.target.value.replace(/\D/, ''),
            styleTicket: { borderWidth: 1 },
            viewTicket: false,
            whoPress: '',
        });
    }

    handleChangeUser = (event) => {
        this.setState({
            identification: event.target.value.replace(/\D/, ''),
            styleUser: { borderWidth: 1 },
            userTicket: '',
        });
    }

    calculateTotal = () => {
        const total = this.state.selectedTickets.reduce((sum, ticket) => {
            const precio = this.state.rifa.porcentaje_recaudo < 100 ? Number(this.state.rifa.precio) || 0 : Number(ticket.precio) || 0;
            return sum + precio;
        }, 0);
        return total;
    }

    navigateNext = (flag, response) => {
        if (flag) {
            const rifa = JSON.parse(localStorage.getItem('datosRifa'));
            let data = [];
            const numbers = this.state.selectedTickets.map((item) => item.numero).join(',');
            let ticketData = [
                'Factura No: ' + response.valida.id,
                'Fecha: ' + response.valida.fecha,
                'No.Aprobacion: ' + response.valida.numero_aprobacion,
                'Producto: ' + rifa.name,
                'Resolucion: ' + rifa.resolucion,
                'Fecha del sorteo: ' + rifa.sorteo,
                'Número de boleta: ' + numbers,
                'Cliente: ' + this.state.userTicket,
                'Valor: ' + FormatMoney(this.calculateTotal()),
            ];
            if (rifa.precio > this.state.selectedPrice) {
                ticketData = [
                    'Factura No: ' + response.valida.id,
                    'Fecha: ' + response.valida.fecha,
                    'No.Aprobacion: ' + response.valida.numero_aprobacion,
                    'Producto: Abono ' + rifa.name,
                    'Resolucion: ' + rifa.resolucion,
                    'Fecha del sorteo: ' + rifa.sorteo,
                    'Número de boleta: ' + numbers,
                    'Cliente: ' + this.state.userTicket,
                    'Valor total: ' + FormatMoney(rifa.precio),
                    'Valor abonado: ' + FormatMoney(parseInt(this.state.selectedPrice)),
                    'Valor por pagar: ' + FormatMoney(rifa.precio - this.state.selectedPrice),
                ];
            }
            data.push(ticketData);
            console.log('data para pdf', data);

            data.forEach((ticketInfo) => jsPdfGenerator(ticketInfo));

            this.props.history.push('/Servicios');
            toast.success('Boleta(s) comprada(s) correctamente');
            this.setState({
                modalNotification: true,
                loading: false,
                opacity: 1,
                userTicket: '',
                viewTicket: false,
                selectedPrice: '',
                numberTicket: '',
                styleTicket: { borderWidth: 1 },
                styleUser: { borderWidth: 1 },
                identification: '',
                selectedTickets: [],
                pricesDisabled: false,
                buyMessage: <></>,
            });
        } else {
            const errorMessage = ManagmentErrors(response.errores.id);
            toast.error(errorMessage);
            this.setState({ loading: false, opacity: 1 });
        }
    }

    payTicket = () => {
        const user = Desencrypt();
        const price = parseInt(String(this.state.selectedPrice || '0').replace(/[^0-9]/g, ''), 10);
        console.log('price.....', price, this.state.rifa.porcentaje_recaudo, this.state.rifa.precio);

        if (price < (this.state.rifa.precio * this.state.rifa.porcentaje_recaudo) / 100) {
            Swal.fire({
                title: 'Atención',
                text: `Recuerde que el monto mínimo para comprar esta boleta es de ${FormatMoney((this.state.rifa.precio * this.state.rifa.porcentaje_recaudo) / 100)}`,
                icon: 'warning',
                confirmButtonText: 'Entendido',
            });
            return;
        }
        if (price > this.calculateTotal()) {
            Swal.fire({
                title: 'Atención',
                text: `El monto máximo de compra para las boletas seleccionadas es de ${FormatMoney(this.calculateTotal())}`,
                icon: 'warning',
                confirmButtonText: 'Entendido',
            });
            return;
        }

        //-_---------------------__---------__-----_-------------_-_------

        if (this.state.selectedTickets.length === 0) {
            toast.error('Por favor, selecciona al menos una boleta para comprar.');
            return;
        }
        if (!this.state.userTicket || this.state.userTicket === '') {
            toast.error('Por favor, busca y selecciona un cliente.');
            return;
        }
        if (!this.state.selectedPrice || this.state.selectedPrice === '') {
            toast.error('Por favor, selecciona un precio.');
            return;
        }

        this.setState({ loading: true, opacity: 0.4 });

        const productsToBuy = {
            product_id: this.state.idProduct,
            atributes: {
                numeroBoleta: this.state.rifa.porcentaje_recaudo < 100 ? [{
                    numero: this.state.selectedTickets[0]?.numero,
                    precio: this.state.selectedPrice
                }] : this.state.selectedTickets,
                valorPagar: parseInt(this.state.rifa.porcentaje_recaudo < 100 ? this.state.selectedPrice : this.calculateTotal()),
                partner_id: this.state.partner_id,/* 
                vendedor_externo_id: user.id, */
                nombre_cliente: this.state.userTicket,
            },
        };
        console.log('productsToBuy', productsToBuy);

        localStorage.setItem('NumBolet', JSON.stringify(this.state.selectedTickets));
        Transaction(productsToBuy, this.navigateNext);
    }

    price = () => {
        const rifa = JSON.parse(localStorage.getItem('datosRifa'));
        const datoSession = Desencrypt();
        let prices = [];
        const idPadre = localStorage.getItem('idPadre');

        if (
            rifa.porcentaje_recaudo === 100 ||
            datoSession.id === idCardosoVendedor ||
            datoSession.id === idMobilgoVendedor
        ) {
            prices = [rifa.precio];
        } else if (datoSession.id === idCallcenter) {
            prices = [rifa.precio, 'Reservar'];
        } else if (idPadre === idPadreRata) {
            if ((rifa.precio * rifa.porcentaje_recaudo) / 100 > 0) {
                prices = [
                    (rifa.precio * rifa.porcentaje_recaudo) / 100,
                    rifa.precio / 2,
                    rifa.precio,
                    'Otro valor',
                    'Reservar',
                ];
            } else {
                prices = ['Reservar', rifa.precio / 2, rifa.precio, 'Otro valor'];
            }
        } else {
            if ((rifa.precio * rifa.porcentaje_recaudo) / 100 > 0) {
                prices = [(rifa.precio * rifa.porcentaje_recaudo) / 100, rifa.precio / 2, rifa.precio, 'Otro valor'];
            } else {
                prices = [rifa.precio / 2, rifa.precio, 'Otro valor'];
            }
        }
        this.setState({ prices });
    }

    generatedLink = async () => {
        const idPadre = localStorage.getItem('idPadre');
        const session = await Desencrypt();
        const numbers = this.state.selectedTickets.map((item) => item.numero).join(',');

        const urlPago = `${Url_pago}PagosExternos/?${this.state.idProduct}&&${session.id}&&${numbers}&&${this.calculateTotal()}&&${this.state.partner_id}&&${this.state.userTicket.trim()}&&${this.state.rifa.name.trim()}&&${this.state.rifa.resolucion}&&${this.state.rifa.sorteo}&&${this.state.rifa.precio}&&${this.state.identification}&&${this.state.userPhone}&&${this.state.userEmail}&&${this.state.rifa.operador_efectivo}&&${this.state.fullNameUser}`;

        if (
            'share' in navigator &&
            session.id !== idCardosoVendedor &&
            session.id !== idMobilgoVendedor &&
            session.id !== idvendedorqr
        ) {
            navigator
                .share({
                    title: 'Compartir link',
                    text: 'Link de pago Rifa MovilGo: ' + this.state.rifa.name,
                    url: urlPago.replace(/\s+/g, ''),
                })
                .then(() => {
                    alert('Se compartió el link');
                    window.location.href = Url_Home;
                })
                .catch(() => {
                    alert('No se pudo compartir');
                });
        } else {
            window.open(urlPago.replace(/\s+/g, ''), '_blank');
            window.location.href = Url_Home;
        }
    }

    render() {
        const rifa = JSON.parse(localStorage.getItem('datosRifa'));
        const session = Desencrypt();
        const idPadre = localStorage.getItem('idPadre');

        return (
            <div className="compras-container">
                <h2 className="default-title">
                    {this.state.selectedTickets.length > 0 && rifa.porcentaje_recaudo === 100 ? 'PUEDES SELECCIONAR MÁS BOLETOS' : 'BOLETAS DISPONIBLES'}
                </h2>
                <h6 className="default-subtitle">
                    {this.state.selectedTickets.length > 0 && rifa.porcentaje_recaudo === 100
                        ? 'Selecciona más boletas preferidas'
                        : 'Elige tu número de boleta buscando o generando números aleatorios'}
                </h6>
                <div style={{ marginTop: '40px', opacity: this.state.opacity }}>
                    <ToastContainer autoClose={2000} />
                    <Row className="justify-content-md-center">
                        <Col md={1} xs={1} sm={1} lg={1}></Col>
                        <Col md={5} xs={12} sm={12} lg={5}>
                            <Image
                                className="carro"
                                src={'data:image/jpeg;base64,' + rifa.imagen}
                                style={{ maxHeight: '90%', maxWidth: '100%' }}
                            />
                        </Col>
                        <Col md={5} xs={12} sm={12} lg={5}>
                            <Row className="justify-content-md-center">
                                <Card className="ticket-card">
                                    <Card.Body>
                                        <Col xs="auto">
                                            <div>
                                                <InputGroup className="custom-input-group mb-3">
                                                    <FormControl
                                                        className="custom-form-control"
                                                        style={this.state.styleUser}
                                                        type="number"
                                                        placeholder="Cédula"
                                                        aria-label="Número de identificación"
                                                        value={this.state.identification}
                                                        onChange={this.handleChangeUser}
                                                    />
                                                    <InputGroup.Text className="custom-input-group-text" onClick={this.findClient}>
                                                        <FontAwesomeIcon className="mr-2 align-self-center" icon={faSearch} />
                                                    </InputGroup.Text>
                                                </InputGroup>

                                                <p className="rifa-info-text">
                                                    {rifa.name} <br />
                                                    {rifa.sorteo} <br />
                                                    {FormatMoney(rifa.precio)} <br />
                                                    Cliente: <span className="client-name-text">{this.state.userTicket}</span>
                                                </p>

                                                {this.state.selectedTickets.length > 0 && (
                                                    <div className="selected-tickets-container">
                                                        {rifa.porcentaje_recaudo === 100 ? <p className="selected-tickets-title">Boletas seleccionadas:</p> : <p className="selected-tickets-title">Boleta seleccionada:</p>}
                                                        <div className="selected-tickets-chips-wrapper">
                                                            {this.state.selectedTickets.map((ticket) => (
                                                                <span key={ticket.id} className="selected-ticket-chip">
                                                                    {ticket.numero}
                                                                    <FontAwesomeIcon
                                                                        icon={faTimesCircle}
                                                                        onClick={() => this.removeSelectedTicket(ticket.id)}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <h5 className="total-amount-text">
                                                            Total: {FormatMoney(this.calculateTotal())}
                                                        </h5>
                                                        {rifa.porcentaje_recaudo === 100 &&
                                                            <p className="add-ticket-text">
                                                                ¡Puedes agregar más boletos!
                                                            </p>}
                                                        <InputGroup className="custom-input-group mb-3">
                                                            <FormControl
                                                                className="custom-form-control"
                                                                style={this.state.styleTicket}
                                                                type="number"
                                                                placeholder="Busca otro número"
                                                                aria-label="Número de la boleta"
                                                                value={rifa.porcentaje_recaudo !== 100 ? this.state.selectedTickets[0]?.numero : this.state.numberTicket}
                                                                onChange={this.handleChange}
                                                                onInput={(e) => {
                                                                    if (e.target.value.length > 4) {
                                                                        e.target.value = e.target.value.slice(0, 4);
                                                                    }
                                                                }}
                                                                inputMode="numeric"
                                                                pattern="[0-9]{4}"
                                                            />
                                                            <InputGroup.Text className="custom-input-group-text" onClick={this.searchTicket}>
                                                                <FontAwesomeIcon className="mr-2 align-self-center" icon={faSearch} />
                                                            </InputGroup.Text>
                                                        </InputGroup>
                                                        <Button
                                                            className="ticket-random-btn mb-3"
                                                            variant="info"
                                                            onClick={() => this.numeroDeLaSuerte()}
                                                        >
                                                            Números para Jugar
                                                        </Button>
                                                    </div>
                                                )}

                                                {this.state.selectedTickets.length === 0 && (
                                                    <div>
                                                        <InputGroup className="custom-input-group mb-3">
                                                            <FormControl
                                                                className="custom-form-control"
                                                                style={this.state.styleTicket}
                                                                type="number"
                                                                placeholder="Busca un número"
                                                                aria-label="Número de la boleta"
                                                                value={this.state.numberTicket}
                                                                onChange={this.handleChange}
                                                                onInput={(e) => {
                                                                    if (e.target.value.length > 4) {
                                                                        e.target.value = e.target.value.slice(0, 4);
                                                                    }
                                                                }}
                                                                inputMode="numeric"
                                                                pattern="[0-9]{4}"
                                                            />
                                                            <InputGroup.Text className="custom-input-group-text" onClick={this.searchTicket}>
                                                                <FontAwesomeIcon className="mr-2 align-self-center" icon={faSearch} />
                                                            </InputGroup.Text>
                                                        </InputGroup>
                                                        <Button
                                                            className="ticket-random-btn mb-3"
                                                            variant="info"
                                                            onClick={() => this.numeroDeLaSuerte()}
                                                        >
                                                            Números para Jugar
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Card.Body>
                                </Card>
                            </Row>
                            <Row className="justify-content-md-center precio">
                                <div className="prices-container">
                                    <ListPrices
                                        onClick={(i) => this.selectPrice(i)}
                                        prices={rifa.porcentaje_recaudo === 100 ? (this.calculateTotal() ? [this.calculateTotal()] : this.state.prices) : this.state.prices}
                                        disabled={this.state.pricesDisabled}
                                        selectedPrice={this.state.selectedPrice}
                                    />
                                    {this.state.visible && (
                                        <NumberFormat
                                            className="form-control mt-3 ticket-price-input"
                                            thousandSeparator={true}
                                            prefix="$ "
                                            placeholder="$ Montos de Mil"
                                            maxLength={9}
                                            value={this.state.selectedPrice}
                                            onValueChange={(values) => {
                                                this.setState({ selectedPrice: values.floatValue || '' });
                                                this.calcularAbono(values.floatValue || 0, rifa.precio);
                                            }}
                                        />
                                    )}
                                </div>
                            </Row>
                            <Row className="justify-content-md-center">
                                <div className="buy-message">{this.state.selectedPrice !== 0 ? this.state.buyMessage : ''}</div>
                            </Row>
                            <Row className="justify-content-md-center buttons-container">
                                {this.state.userTicket && this.state.selectedTickets.length > 0 && this.state.selectedPrice && this.state.showcomprar && this.state.selectedPrice !== '0' && (
                                    <Button onClick={this.payTicket} variant="info" className="ticket-action-btn">
                                        Comprar
                                    </Button>
                                )}
                                {this.state.userTicket && this.state.selectedTickets.length > 0 && this.state.selectedPrice && this.state.selectedPrice !== '0' && (
                                    <Button onClick={this.generatedLink} variant="success" className="ticket-action-btn">
                                        Generar pago
                                    </Button>
                                )}
                                {this.state.userTicket && this.state.selectedTickets.length > 0 && this.state.selectedPrice === '0' && (idCallcenter === session.id || idPadreRata === idPadre) && (
                                    <Button onClick={this.payTicket} variant="info" className="ticket-action-btn">
                                        Reservar Boleta
                                    </Button>
                                )}
                            </Row>
                        </Col>
                        <Col md={1} xs={1} sm={1} lg={1}></Col>
                    </Row>
                </div>
                <ModalRegistro
                    cedula={this.state.identification}
                    setCliente={(cedula, nombre) =>
                        this.setState({
                            userTicket: cedula + ' - ' + nombre,
                            styleUser: { borderWidth: 2, borderColor: '#00A3B6' },
                        })
                    }
                    id_product={rifa.id}
                    visible={this.state.visibleRegistro}
                    setParther={(id) => this.setState({ partner_id: id })}
                    closeModal={(flag) => {
                        this.showModalRegistro(flag);
                        this.setState({ opacity: 1 });
                    }}
                />
                {this.state.visibleBoletas && (
                    <ModalBoletas
                        selectTicket={(number) => this.selectTicket(number)}
                        chooseTicket={(flag) => { this.chooseTicket(flag); this.setState({ numberTicket: '' }) }}
                        numbersTicket={this.numbersTicket}
                        selectedTickets={this.state.selectedTickets}
                        visible={this.state.visibleBoletas}
                        closeModal={(flag) => this.chooseTicket(flag)}
                    />
                )}
                {this.state.loading && <LoadingMovilGo />}
                {this.state.modalNotification && (
                    <ModalNotificationTransaction
                        closeModal={(flag) => this.setState({ modalNotification: flag })}
                        type="Rifa"
                        message="Rifa comprada exitosamente"
                    />
                )}
            </div>
        );
    }
}

export default Compras;